import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface InactiveCaseAlertProps {
  id: string;
  clientName: string;
  caseTitle: string;
  inactivityDays: number;
  onViewCase: (caseId: string) => void;
  onClose: (id: string) => void;
}

export const InactiveCaseAlert: React.FC<InactiveCaseAlertProps> = ({
  id,
  clientName,
  caseTitle,
  inactivityDays,
  onViewCase,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 10000); // Alerta desaparece após 10 segundos

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    onClose(id);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: 300 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 300 }}
          transition={{ duration: 0.5 }}
          className="fixed bottom-4 right-4 bg-red-600 text-white p-4 rounded-lg shadow-lg flex items-center space-x-4 z-50 max-w-sm"
        >
          <AlertTriangle className="w-6 h-6 flex-shrink-0" />
          <div className="flex-grow">
            <p className="font-semibold">Atenção!</p>
            <p className="text-sm">
              O processo <span className="font-medium">"{caseTitle}"</span> do cliente <span className="font-medium">{clientName}</span> está há <span className="font-medium">{inactivityDays} dias</span> sem movimentação.
            </p>
          </div>
          <div className="flex flex-col space-y-2">
            <Button
              variant="secondary"
              size="sm"
              onClick={() => onViewCase(id)}
              className="w-full"
            >
              Ver Processo
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleClose}
              className="w-full text-white hover:bg-red-700 hover:text-white"
            >
              <X className="w-4 h-4 mr-1" /> Fechar
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};